export default "__VITE_ASSET__g$olizMZuZSrwHhyt1dNbg__"